<template>
  <div class="about">
    <img class="mdl-cell mdl-cell--2-col" src="../assets/logo.png" alt="Perlclip PWA">
  </div>
</template>

<script>
export default {
  name: 'about'
}
</script>



// WEBPACK FOOTER //
// src/components/About.vue